/**
 * * Настройки сортировки задач
 */
export default class SortingSettingsTask  {
	/**
	 * * Флаг сортировки по убыванию по идентификатору таски
	 */
	OrderDescendingByTaskId?: boolean = false;
	/**
	 * * Флаг сортировки по убыванию по имени
	 */
	OrderDescendingByName?: boolean = false;
	/**
	 * * Флаг сортировки по убыванию по оценки времени
	 */
	OrderDescendingByEstimates?: boolean = false;
	/**
	 * * Флаг сортировки по убыванию по затраченному времени
	 */
	OrderDescendingBySpent?: boolean = false;
	constructor(obj?: Partial<SortingSettingsTask>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
